export default defineNuxtPlugin(() => {
  if (import.meta.dev || import.meta.server) {
    return
  }

  const router = useRouter()
  const vacancyRoute = router.resolve({
    name: 'thuisgekookt-vacatures-slug',
    params: { slug: 'full-stack-developer-stagiair' }
  })

  const fullUrl = `${window.location.origin}${vacancyRoute.href}`

  console.log(
    `%c                                                                              
  █████████   █████     ███           █████       █████     ███                                                     
 ███▒▒▒▒▒███ ▒▒███     ▒▒▒           ▒▒███       ▒▒███     ▒▒▒                                                      
▒███    ▒▒▒  ███████   ████   ██████  ▒███████   ███████   ████  ████████    ███████                                
▒▒█████████ ▒▒▒███▒   ▒▒███  ███▒▒███ ▒███▒▒███ ▒▒▒███▒   ▒▒███ ▒▒███▒▒███  ███▒▒███                                
 ▒▒▒▒▒▒▒▒███  ▒███     ▒███ ▒███ ▒▒▒  ▒███ ▒███   ▒███     ▒███  ▒███ ▒███ ▒███ ▒███                                
 ███    ▒███  ▒███ ███ ▒███ ▒███  ███ ▒███ ▒███   ▒███ ███ ▒███  ▒███ ▒███ ▒███ ▒███                                
▒▒█████████   ▒▒█████  █████▒▒██████  ████ █████  ▒▒█████  █████ ████ █████▒▒███████                                
 ▒▒▒▒▒▒▒▒▒     ▒▒▒▒▒  ▒▒▒▒▒  ▒▒▒▒▒▒  ▒▒▒▒ ▒▒▒▒▒    ▒▒▒▒▒  ▒▒▒▒▒ ▒▒▒▒ ▒▒▒▒▒  ▒▒▒▒▒███                                
                                                                            ███ ▒███                                
                                                                           ▒▒██████                                 
                                                                            ▒▒▒▒▒▒                                  
%c ███████████ █████                  ███                            █████                        █████       █████   
▒█▒▒▒███▒▒▒█▒▒███                  ▒▒▒                            ▒▒███                        ▒▒███       ▒▒███    
▒   ▒███  ▒  ▒███████   █████ ████ ████   █████   ███████  ██████  ▒███ █████  ██████   ██████  ▒███ █████ ███████  
    ▒███     ▒███▒▒███ ▒▒███ ▒███ ▒▒███  ███▒▒   ███▒▒███ ███▒▒███ ▒███▒▒███  ███▒▒███ ███▒▒███ ▒███▒▒███ ▒▒▒███▒   
    ▒███     ▒███ ▒███  ▒███ ▒███  ▒███ ▒▒█████ ▒███ ▒███▒███████  ▒██████▒  ▒███ ▒███▒███ ▒███ ▒██████▒    ▒███    
    ▒███     ▒███ ▒███  ▒███ ▒███  ▒███  ▒▒▒▒███▒███ ▒███▒███▒▒▒   ▒███▒▒███ ▒███ ▒███▒███ ▒███ ▒███▒▒███   ▒███ ███
    █████    ████ █████ ▒▒████████ █████ ██████ ▒▒███████▒▒██████  ████ █████▒▒██████ ▒▒██████  ████ █████  ▒▒█████ 
   ▒▒▒▒▒    ▒▒▒▒ ▒▒▒▒▒   ▒▒▒▒▒▒▒▒ ▒▒▒▒▒ ▒▒▒▒▒▒   ▒▒▒▒▒███ ▒▒▒▒▒▒  ▒▒▒▒ ▒▒▒▒▒  ▒▒▒▒▒▒   ▒▒▒▒▒▒  ▒▒▒▒ ▒▒▒▒▒    ▒▒▒▒▒  
                                                 ███ ▒███                                                           
                                                ▒▒██████                                                            
                                                 ▒▒▒▒▒▒             %c`,
    '',
    'color: #2E6B53; font: 400 1em monospace;',
    ''
  )

  window.console.log(`Op zoek naar een stage? Lees hier de vacature:\n👉 ${fullUrl}`)
})
